<script setup lang="ts">
import { computed } from "vue";

import { backendOld } from "~/api";
import SettingsCopyText from "~/components/settings/SettingsCopyText.vue";
import type { User } from "~/shared/types";
import { useDataStore, useEnvironmentStore } from "~/stores";

const props = defineProps<{
  agent: User;
}>();

const ROTATE_WEBHOOK_DIALOG_DESCRIPTION =
  "Rotating the agent webhook URL will invalidate the old URL and make a new one. This can't be undone. Are you sure you want to proceed?";
const DELETE_WEBHOOK_DIALOG_DESCRIPTION =
  "Deleting the agent webhook URL will invalidate the old URL. This can't be undone. Are you sure you want to proceed?";

const dataStore = useDataStore();
const environmentStore = useEnvironmentStore();

const link = computed(() =>
  props.agent.webhookDuid ? `${environmentStore.urlBase}/api/v0/agent-webhooks/${props.agent.webhookDuid}` : null
);

const rotateWebhook = async () => {
  const { data } = await backendOld.agents.rotateWebhook(props.agent.duid);
  dataStore.$createOrUpdateUser({ ...props.agent, webhookDuid: data.webhookDuid });
};

const deleteWebhook = async () => {
  dataStore.$createOrUpdateUser({ ...props.agent, webhookDuid: null });
  await backendOld.agents.deleteWebhook(props.agent.duid);
};
</script>

<template>
  <div class="flex select-none flex-col gap-1">
    <div class="text-sm text-md">Webhook URL</div>
    <SettingsCopyText
      :text="link"
      label="Webhook URL"
      :rotate-dialog-description="ROTATE_WEBHOOK_DIALOG_DESCRIPTION"
      :delete-dialog-description="DELETE_WEBHOOK_DIALOG_DESCRIPTION"
      :on-rotate-or-create="rotateWebhook"
      @delete="deleteWebhook" />
  </div>
</template>
